import styled from 'styled-components';

import { StatusTableItem } from 'ui/statusTableItem/StatusTableItem';

export const HistoryActionOption = styled(StatusTableItem)`
  padding: 6px;
`;
